import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyRecievedCorrectiveParamsType,
  GetBodyRecievedCorrectiveResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyRecievedCorrectiveImages/getBodyRecievedCorrectiveImages.type';

export const getBodyRecievedCorrectiveImagesFunction = (
  params: GetBodyRecievedCorrectiveParamsType,
): Promise<GetBodyRecievedCorrectiveResponseType> => {
  return fetchApi.get(
    `/body/reports/${params.id}/images/corrective/receive/list/`,
  );
};
